import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Optional,
} from '@angular/core';

import { SIDENAV_CONTAINER } from '../sidenav-container.token';
import { SidenavContainerComponent } from '../sidenav-container/sidenav-container.component';

@Component({
  selector: 'app-sidenav-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss'],
  host: {
    class: 'sidenav-content',
    '[style.margin-left.px]': '_container?.contentMarginLeft',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavContentComponent {
  constructor(
    @Optional()
    @Inject(SIDENAV_CONTAINER)
    public _container: SidenavContainerComponent
  ) {}
}
